import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationArrivalRatesPerService from "../../../components/organization/reports/daily/OrganizationArrivalRatesPerService";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationArrivalRatesPerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="ArrivalRatesByService"
    title={`${reportIndex}. Arrival Rates Per Service`}
  >
    {({ data, renderConfig }) => (
      <OrganizationArrivalRatesPerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationArrivalRatesPerService;
